import { ExternalUser, User, UserType } from '@/models/User';
import { Project, ProjectListProject } from '@/views/project-forum/models/ProjectForum';
import { InvoiceBaseUserWithRole } from '@/models/Invoice';

export const DELETED_USER_FULLNAME = 'ehemaliger benutzer';

// eslint-disable-next-line import/prefer-default-export
export const getUserType = (user:User): UserType => {
  if (user?.role === 'COMPANY_ROOT' || user?.companyRole === 'ROOT' || user?.roles?.includes('COMPANY_ROOT')) return UserType.COMPANY;
  if (user?.role === 'COMPANY_GUEST' || user?.companyRole === 'GUEST' || user?.roles?.includes('COMPANY_GUEST')) return UserType.GUEST;
  if (user?.role === 'COMPANY_EMPLOYEE' || user?.companyRole === 'EMPLOYEE' || user?.roles?.includes('COMPANY_EMPLOYEE')) return UserType.EMPLOYEE;
  return UserType.FREELANCER;
};

export const isDeletedUser = (user: Pick<User, 'fullname' | 'firstname' | 'lastname'> | null | undefined) => {
  const fullname = (user?.fullname ?? `${user?.firstname ?? ''} ${user?.lastname ?? ''}`).trim().toLowerCase();
  return fullname === DELETED_USER_FULLNAME;
};

export const userNames = (user:User) => ({
  firstname: user?.firstname ?? '',
  lastname: user?.lastname ?? '',
  fullname: `${user?.firstname ?? ''} ${user?.lastname ?? ''}`,
  companyname: user?.company?.name ?? '',
});

export const getUserTypeTranslationKey = (key:string, userType: UserType) => key.replaceAll('_USERTYPE', `_${userType}`);

export const getDisplayName = (user: User | ExternalUser | InvoiceBaseUserWithRole | undefined) => {
  if (user?.company && (('role' in user && user.role === 'COMPANY_ROOT') || user.companyRole === 'ROOT')) {
    return user?.company?.name || '';
  }
  return `${user?.firstname} ${user?.lastname}`;
};

export const getNameSortString = (user: User | ExternalUser | InvoiceBaseUserWithRole) => {
  if (user?.company && 'role' in user && user.role === 'COMPANY_ROOT') return user?.company ?? '';
  return user?.lastname ?? '';
};

export const getProjectCreatorName = (project: Project | ProjectListProject) => {
  const creator = project?.creator;

  return getDisplayName(creator);
};

export function extractCityName(input: string, type: 'zip' | 'city' = 'city') {
  const match = input.match(/^\s*([^,]+)\s*,\s*(.+)\s*$/);
  if (!match) return input;

  const [, zip, city] = match;
  return type === 'zip' ? zip : city;
}
